
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jIcpb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e59bbfc9e5f1eded$var$_react = $e59bbfc9e5f1eded$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $e59bbfc9e5f1eded$var$_filter = $e59bbfc9e5f1eded$var$_interopRequireDefault((parcelRequire("4AkKf")));
function $e59bbfc9e5f1eded$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e59bbfc9e5f1eded$var$FilterIcon = (props)=>/*#__PURE__*/ $e59bbfc9e5f1eded$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $e59bbfc9e5f1eded$var$_filter.default
    }));
$e59bbfc9e5f1eded$var$FilterIcon.displayName = 'FilterIcon';
var $e59bbfc9e5f1eded$var$_default = module.exports.default = $e59bbfc9e5f1eded$var$FilterIcon;

});


//# sourceMappingURL=filter.7bab822f.js.map
